angular.module('zc.projects')

.directive 'campaignTable', ($state, $filter, $q, Project, Campaign, CampaignStats, ReportCampaignStats, ReportRange, Devise) ->
  restrict: 'A'
  scope:
    project: '='
    campaigns: '='
    filters: '='
    showActions: '='
    showStats: '='
    showCampaignDetail: '='
    showControlPercent: '='
    showClearanceSettings: '='
    showHiddenAb: '='
    hasHiddenAb: '='
    isAb: '='
    isReport: '='
    status: '='
    onUpdate: '&'
    canShowInvoiceAmount: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_table.html'

  link: (scope, element, attrs) ->
    scope.Devise = Devise
    scope.pagination =
      itemsPerPage: 25
      currentPage: 1
    scope.Project = Project
    scope.sortedCampaigns = []
    scope.canAddIncentive = false
    scope.vm =
      id: Math.floor(Math.random() * 10)
      selected: false

    scope.pageChanged = ->
      begin = scope.pagination.itemsPerPage * (scope.pagination.currentPage - 1)
      end = begin + scope.pagination.itemsPerPage
      scope.sortedCampaigns = _.orderBy(scope.campaigns, ['current_status', 'id'], ['asc', 'desc'])
      scope.pagedCampaigns = scope.sortedCampaigns.slice begin, end
      scope.canAddIncentive = Devise.isMaster() and _.some(scope.sortedCampaigns, (campaign) -> Campaign.canAddIncentive(campaign))
      if scope.showStats
        if scope.isReport
          getReportCampaignStats()
        else
          getCampaignStats()

    getCampaignStats = ->
      return unless scope.pagedCampaigns.length
      apikey = scope.pagedCampaigns[0].apikey
      campaign_ids = (campaign.id for campaign in scope.pagedCampaigns)
      CampaignStats.aggregate
        dimension: 'daily'
        apikey: apikey
        campaign_ids: campaign_ids
        start_at: scope.filters.start_at
        end_at: scope.filters.end_at
      .then (campaign_stats) ->
        statsById = CampaignStats.groupById campaign_stats
        for campaign in scope.pagedCampaigns
          campaign.stats = statsById[campaign.id]
          calculatedInvoiceAmount = CampaignStats.calculateInvoiceAmount(scope.project, campaign, campaign.stats)
          _.assign campaign.stats,
            invoice_amount: calculatedInvoiceAmount

    getReportCampaignStats = ->
      return unless scope.pagedCampaigns.length
      apikey = scope.pagedCampaigns[0].apikey
      ReportCampaignStats.find
        apikey: apikey
        dimension: scope.filters.dimension
      ,
        match:
          status: scope.status
          begin_at: scope.filters.begin_at
          start_at: scope.filters.start_at if scope.filters.start_at
      .then (report_campaign_stats) ->
        statsById = _.keyBy report_campaign_stats, 'campaign_id'
        for campaign in scope.pagedCampaigns
          campaign.stats = statsById[campaign.id]

    scope.$watchCollection 'campaigns', (newValue) ->
      return unless newValue
      scope.campaigns = newValue
      scope.pageChanged()

    scope.$watch 'filters', (newValue) ->
      return unless newValue
      scope.filters = newValue
      scope.pageChanged()

    scope.$watch 'vm', (vm) ->
      scope.sortedCampaigns.forEach (campaign) ->
        campaign.selected = vm.selected if Campaign.canAddIncentive(campaign)
    , true

    scope.$watch 'sortedCampaigns', (newCampaigns) ->
      selectable = _.filter newCampaigns, (campaign) -> Campaign.canAddIncentive(campaign)
      selected = _.every selectable, (campaign) -> campaign.selected
      if selected
        scope.vm.selected = true
        return
      deselected = _.every selectable, (campaign) -> not campaign.selected
      if deselected
        scope.vm.selected = false
        return
    , true



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_table.js.coffee